// composables/UseBatteryMeasure.js
// ---------------------------------------------
// Valida si el botón "Buscar" para baterías debe
// estar deshabilitado, usando el bridge de carrito.
//
// Requisitos de negocio (igual que antes):
// - Patente vacía o con menos de 6 caracteres  -> deshabilitado
// - Sin latitud/longitud válidas en la ubicación -> deshabilitado
//
// Implementación:
// - Usa useCartBridge({ namespace: 'baterias' }) para leer ubication.
// - No usa shoppingCartModule.
// - No llama useStore() fuera de setup/composable.
// ---------------------------------------------

import { useCartBridge } from '~/composables/useCartBridge'

const UseBatteryMeasure = () => {
  // Nos conectamos explícitamente al módulo de carrito de BATERÍAS.
  // Si en el futuro quisieras hacerlo dinámico por modo_sistema,
  // puedes extender esto, pero aquí mantenemos el foco en baterías.
  const cart = useCartBridge({ namespace: 'baterias' })

  // cart.ubication es un computed que viene del bridge
  const { ubication } = cart

  /**
   * Determina si debe estar deshabilitado el flujo de búsqueda por patente.
   *
   * Regla:
   * - currentPlate vacío o con largo < 6  => true
   * - ubication.sin lat/lng válidas      => true
   * - caso contrario                     => false
   */
  const isDisabledCar = (currentPlate) => {
    const plateInvalid = !currentPlate || currentPlate.length < 6

    const u = ubication.value || {}

    const missingLat =
      u.latitude == null ||
      u.latitude === 0 ||
      u.latitude === '' ||
      Number.isNaN(Number(u.latitude))

    const missingLng =
      u.longitude == null ||
      u.longitude === 0 ||
      u.longitude === '' ||
      Number.isNaN(Number(u.longitude))

    return plateInvalid || missingLat || missingLng
  }

  return {
    isDisabledCar,
    ubication,
  }
}

export default UseBatteryMeasure
